export const departmantGenerateColumns = (data: any) => {
  const columns: any = [];

  data.forEach((item: any) => {
    columns.push({
      headerName: item.name,
      field: item._id,
      width: 150,
      editable: true,
      cellRenderer: 'agCheckboxCellRenderer',
      cellEditor: 'agCheckboxCellEditor',
      valueSetter: (params: any) => {
        params.data[params.colDef.field] = params.newValue;
        return true;
      }
    });
  });

  return columns;
};
